import React, { Component } from 'react';
import {
    Table,
    TableBody,
    TableHeader,
    TableHeaderColumn,
    TableRow,
    TableRowColumn,
} from 'material-ui/Table';
import RaisedButton from 'material-ui/RaisedButton';

const tableState = {
    fixedHeader: true,
    fixedFooter: true,
    stripedRows: false,
    showRowHover: false,
    selectable: true,
    multiSelectable: true,
    enableSelectAll: true,
    deselectOnClickaway: false,
    height: '500px',
};

class InvoicesTable extends Component {
    render() {
        const invoiceNodes = this.props.invoices.map(invoice => (
            <TableRow key={invoice.get('id')}>
                <TableRowColumn>{invoice.get('sendDate')}</TableRowColumn>
                <TableRowColumn>{invoice.get('dueDate')}</TableRowColumn>
                <TableRowColumn>{invoice.get('amount')}</TableRowColumn>
                <TableRowColumn>
                    <RaisedButton
                        label="Rechnung herunterladen"
                        onClick={() => {
                            this.props.generateInvoicePDF({
                                id: invoice.get('id'),
                                contractId: invoice.get('contractId'),
                            });
                        }}
                    />
                </TableRowColumn>
            </TableRow>
        ));

        return (
            <Table
                height={tableState.height}
                fixedHeader={tableState.fixedHeader}
                fixedFooter={tableState.fixedFooter}
                selectable={false}
                multiSelectable={tableState.multiSelectable}
                onRowSelection={this.props.onRowSelection}>
                <TableHeader
                    enableSelectAll={tableState.enableSelectAll}
                    displaySelectAll={false}
                    adjustForCheckbox={false}>
                    <TableRow>
                        <TableHeaderColumn tooltip="Rechnungsdatum">
                            Rechnungsdatum
                        </TableHeaderColumn>
                        <TableHeaderColumn tooltip="Fällig am">Fällig am</TableHeaderColumn>
                        <TableHeaderColumn tooltip="Rechnungsbetrag">
                            Rechnungsbetrag
                        </TableHeaderColumn>
                        <TableHeaderColumn tooltip="PDF">PDF</TableHeaderColumn>
                    </TableRow>
                </TableHeader>
                <TableBody
                    deselectOnClickaway={tableState.deselectOnClickaway}
                    displayRowCheckbox={false}>
                    {invoiceNodes}
                </TableBody>
            </Table>
        );
    }
}

export default InvoicesTable;
